import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import i18n, { initI18n } from './i18n';
import { applyTheme, getStoredTheme } from './lib/theme';
import './styles/global.css';

initI18n();
applyTheme(getStoredTheme());
document.documentElement.lang = i18n.resolvedLanguage ?? 'de';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </I18nextProvider>
  </StrictMode>,
);
